"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AnnotationRendererV = _interopRequireDefault(require("./v1/AnnotationRendererV1"));

var _AnnotationRendererV2 = _interopRequireDefault(require("./v2/AnnotationRendererV2"));

var _AnnotationRendererV3 = _interopRequireDefault(require("./v3/AnnotationRendererV3"));

var _AnnotationCreatorV = _interopRequireDefault(require("./v3/AnnotationCreatorV3"));

var _AnnotationSchemaV = _interopRequireDefault(require("./v3/AnnotationSchemaV3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VERSION_1 = 1;
var VERSION_2 = 2;
var VERSION_3 = 3;

var AnnotationFactory = /*#__PURE__*/function () {
  function AnnotationFactory() {
    _classCallCheck(this, AnnotationFactory);
  }

  _createClass(AnnotationFactory, null, [{
    key: "getRenderer",
    value:
    /**
     * Create a new annotation renderer based on the data version
     * @param {number} version
     * @param {Element} element
     * @param {Object} annotationData
     * @param {AnnotationHelper} annotationHelper
     * @returns {*}
     */
    function getRenderer(version, element, annotationData, annotationHelper) {
      var renderer = null;

      if (version === VERSION_1) {
        renderer = new _AnnotationRendererV["default"](element, annotationData, annotationHelper);
      } else if (version === VERSION_2) {
        renderer = new _AnnotationRendererV2["default"](element, annotationData, annotationHelper);
      } else if (version === VERSION_3) {
        renderer = new _AnnotationRendererV3["default"](element, annotationData, annotationHelper);
      } else {
        throw new Error("Version {version} not implemented");
      }

      return renderer;
    }
    /**
     * Get an instance of a annotation creator based on the specified version
     * @param {number} version
     * @param {Element} element
     * @param {Object} annotationData
     * @param {AnnotationHelper} annotationHelper
     * @returns {AnnotationCreatorV3}
     */

  }, {
    key: "getCreator",
    value: function getCreator(version, element, annotationData, annotationHelper) {
      var creator = null;

      if (version === VERSION_3) {
        creator = new _AnnotationCreatorV["default"](element, annotationData, annotationHelper);
      }

      return creator;
    }
    /**
     * Get the schema definition for the specified version
     * @param {number} version
     * @returns {AnnotationSchemaV3}
     */

  }, {
    key: "getSchema",
    value: function getSchema(version) {
      var schema = null;

      if (version === VERSION_3) {
        schema = _AnnotationSchemaV["default"];
      }

      return schema;
    }
  }]);

  return AnnotationFactory;
}();

exports["default"] = AnnotationFactory;